// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Data9 from "common/src/data/Data9.bs.js";
import * as React from "react";
import * as Data56 from "common/src/data/Data56.bs.js";
import * as Data95 from "common/src/data/Data95.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TbItemCell from "./TbItemCell.bs.js";

function TbRadiantItemsGrid(Props) {
  var search = Props.search;
  var set = TftSet.use(undefined);
  React.useState(function () {
        return [];
      });
  return React.createElement("div", undefined, React.createElement("div", {
                  className: "border-l border-t border-white1"
                }, Belt_Array.map(Belt_Array.range(1, 8), (function (i) {
                        return React.createElement("div", {
                                    key: String(i),
                                    className: "flex"
                                  }, Belt_Array.map(Belt_Array.range(1, 8), (function (j) {
                                          var match = set !== 56 ? (
                                              set !== 90 ? Data95.gridRadiantItem(i, j) : Data9.gridRadiantItem(i, j)
                                            ) : Data56.gridRadiantItem(i, j);
                                          return React.createElement("div", {
                                                      key: String(Math.imul(i, 10) + j | 0),
                                                      className: "border-r border-b border-white1"
                                                    }, React.createElement(TbItemCell.make, {
                                                          search: search,
                                                          itemId: match[0],
                                                          key: String(Math.imul(i, 10) + j | 0)
                                                        }));
                                        })));
                      }))));
}

var make = TbRadiantItemsGrid;

export {
  make ,
  
}
/* Data9 Not a pure module */
